import { USER_ROLE } from '../utils/constants';

/** Uygulama URL yolları — tek kaynak (Open/Closed) */
export const PATHS = {
  LANDING: '/',
  LOGIN: '/login',
  KVKK: '/kvkk',
  STUDENT: '/student',
  INSTRUCTOR: '/instructor',
};

export const STUDENT_TABS = ['home', 'account'];

/** Eski öğrenci sekmeleri — anasayfaya yönlendirilir */
export const LEGACY_STUDENT_TABS = ['history', 'progress', 'report', 'profile'];

export const INSTRUCTOR_TABS = [
  'dashboard',
  'students',
  'schedule',
  'payments',
  'report',
  'account',
];

/** Eğitmen hesap sayfasının bölümleri (sağ üst profil menüsündeki başlıklar) */
export const INSTRUCTOR_ACCOUNT_SECTIONS = ['overview', 'profile', 'security'];

/** Öğrenci hesap sayfası bölümleri — eğitmen menüsüyle aynı başlıklar */
export const STUDENT_ACCOUNT_SECTIONS = ['overview', 'profile', 'security'];

export const studentTabPath = (tab = 'home') => {
  if (tab === 'account') return `${PATHS.STUDENT}/account`;
  const normalized = STUDENT_TABS.includes(tab) ? tab : 'home';
  return normalized === 'home' ? PATHS.STUDENT : `${PATHS.STUDENT}/${normalized}`;
};

export const studentAccountHubPath = () => `${PATHS.STUDENT}/account`;

export const isStudentAccountHubPath = (pathname = '') => {
  const cleaned = pathname.replace(/\/$/, '') || '/';
  return cleaned === studentAccountHubPath();
};

export const studentAccountPath = (section = 'overview') => {
  const normalized = STUDENT_ACCOUNT_SECTIONS.includes(section) ? section : 'overview';
  return `${PATHS.STUDENT}/account/${normalized}`;
};

export const studentAccountSectionFromPathname = (pathname) => {
  if (isStudentAccountHubPath(pathname)) return 'overview';
  const [tab, section] = pathname.replace(/^\/student\/?/, '').split('/');
  if (tab !== 'account') return 'overview';
  return STUDENT_ACCOUNT_SECTIONS.includes(section) ? section : 'overview';
};

export const instructorTabPath = (tab = 'dashboard') => {
  const normalized = INSTRUCTOR_TABS.includes(tab) ? tab : 'dashboard';
  return `${PATHS.INSTRUCTOR}/${normalized}`;
};

export const instructorStudentPath = (studentId) =>
  `${PATHS.INSTRUCTOR}/students/${studentId}`;

export const instructorAccountHubPath = () => `${PATHS.INSTRUCTOR}/account`;

/** Hesap hub (mobil menü listesi) — /instructor/account */
export const isInstructorAccountHubPath = (pathname = '') => {
  const cleaned = pathname.replace(/\/$/, '') || '/';
  return cleaned === instructorAccountHubPath();
};

export const instructorAccountPath = (section = 'overview') => {
  const normalized = INSTRUCTOR_ACCOUNT_SECTIONS.includes(section) ? section : 'overview';
  return `${PATHS.INSTRUCTOR}/account/${normalized}`;
};

/** URL'den hesap bölümü; /instructor/account (hub) → overview */
export const instructorAccountSectionFromPathname = (pathname) => {
  if (isInstructorAccountHubPath(pathname)) return 'overview';
  const [tab, section] = pathname.replace(/^\/instructor\/?/, '').split('/');
  if (tab !== 'account') return 'overview';
  return INSTRUCTOR_ACCOUNT_SECTIONS.includes(section) ? section : 'overview';
};

/** Eski currentPage string → URL (geriye dönük uyumluluk) */
export const legacyPageToPath = (page) => {
  switch (page) {
    case 'landing':
      return PATHS.LANDING;
    case 'login':
      return PATHS.LOGIN;
    case 'kvkk':
      return PATHS.KVKK;
    case 'student':
      return PATHS.STUDENT;
    case 'instructor':
      return instructorTabPath('dashboard');
    default:
      return PATHS.LANDING;
  }
};

export const portalPathForRole = (role) =>
  role === USER_ROLE.INSTRUCTOR
    ? instructorTabPath('dashboard')
    : PATHS.STUDENT;

/** Misafir (giriş öncesi) yollar */
export const isGuestPath = (pathname) =>
  pathname === PATHS.LANDING || pathname === PATHS.KVKK || pathname === PATHS.LOGIN;

/** Rolün erişebileceği portal yolu mu */
export const isPathAllowedForRole = (pathname, role) => {
  if (role === USER_ROLE.INSTRUCTOR) {
    return pathname === PATHS.INSTRUCTOR || pathname.startsWith(`${PATHS.INSTRUCTOR}/`);
  }
  if (role === USER_ROLE.STUDENT) {
    return pathname === PATHS.STUDENT || pathname.startsWith(`${PATHS.STUDENT}/`);
  }
  return false;
};

/** Auth sonrası hedef: deep link korunur, aksi halde portal kökü */
export const resolvePostAuthPath = (pathname, role) => {
  if (!isGuestPath(pathname) && isPathAllowedForRole(pathname, role)) {
    return pathname;
  }
  return portalPathForRole(role);
};

/** URL'den eğitmen sekme kimliği */
export const instructorTabFromPathname = (pathname) => {
  const segment = pathname.replace(/^\/instructor\/?/, '').split('/')[0];
  if (!segment || segment === '') return 'dashboard';
  if (segment === 'students') return 'students';
  // Eski /instructor/settings bağlantıları hesap sekmesini seçili gösterir
  if (segment === 'settings') return 'account';
  return INSTRUCTOR_TABS.includes(segment) ? segment : 'dashboard';
};

/** URL'den öğrenci sekme kimliği */
export const studentTabFromPathname = (pathname) => {
  const segment = pathname.replace(/^\/student\/?/, '').split('/')[0];
  if (!segment || segment === '') return 'home';
  if (segment === 'account') return 'account';
  if (LEGACY_STUDENT_TABS.includes(segment)) return 'home';
  return STUDENT_TABS.includes(segment) ? segment : 'home';
};
